// import React from 'react';
// import Typography from '@mui/material/Typography';
// import Stack from '@mui/material/Stack';

// export default function AppTitle() {
//     return <Stack direction="column">
//         <Typography
//             variant="h3"
//             component="div"
//             sx={{ flexGrow: 1 }}
//         >
//             PMI SAM DB
//         </Typography>
//         <Typography
//             component="p"
//             sx={{ flexGrow: 1 }}
//         >
//             Strategic Asset Management Database
//         </Typography>
//     </Stack>
// }

// AppTitle.js
import React from 'react';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';

export default function AppTitle({ logo, opt }) {
    const isDS = opt === 'DS';

    return (
        <Stack direction="row" alignItems="center" spacing={2}>
            {!isDS && logo && (
                <img src={logo} alt="SAMDB" height="35px" />
            )}

            <Stack direction="column" spacing={0.5}>
                <Typography variant="h5" component="h1">
                    {isDS ? 'PMI DS DB' : 'PMI SAM DB'}
                </Typography>

                <Typography
                    variant="subtitle2"
                    component="h2"
                    color="text.secondary"
                >
                    {isDS
                        ? 'PMI Design Speed Database'
                        : 'Strategic Asset Management Database'}
                </Typography>
            </Stack>
        </Stack>
    );
}